import { Injectable } from '@angular/core';
import { OverlayHandle, OverlayRole, OverlayService } from './overlay.service';

export interface MpLoadingOptions {
	message?: string;
	spinner?: string | null;
	cssClass?: string | string[];
	duration?: number;
	backdropDismiss?: boolean;
	showBackdrop?: boolean;
	mode?: 'ios' | 'md';
}

/** Drop-in do LoadingController do @ionic/angular (spinner + mensagem, backdrop, dismiss por tempo). */
@Injectable({ providedIn: 'root' })
export class MpLoadingController {
	constructor(private overlay: OverlayService) {}

	create(opts: MpLoadingOptions = {}): Promise<OverlayHandle> {
		// Estrutura do `ion-loading` md (@ionic/core 8.8.13): `.loading-spinner` com um
		// `ion-spinner name="crescent"` dentro, e `.loading-content` com a mensagem. O spinner
		// fica num <div> de bloco com um <span> inline-block de 28px, como o custom element do
		// Ionic — é essa linha que dá os 82px de altura da caixa medidos em produção (a caixa
		// com um <div> de 28px dava 76px).
		const el = document.createElement('div');
		el.className = 'mp-loading';

		if (opts.spinner !== null) {
			const spinner = document.createElement('div');
			spinner.className = 'mp-loading-spinner';
			spinner.setAttribute('aria-hidden', 'true');
			spinner.innerHTML = '<span class="mp-spinner-crescent"><svg viewBox="0 0 64 64"><circle transform="translate(32,32)" r="26"></circle></svg></span>';
			el.appendChild(spinner);
		}

		if (opts.message) {
			const msg = document.createElement('div');
			msg.className = 'mp-loading-content';
			msg.innerHTML = opts.message;
			el.appendChild(msg);
		}

		const handle = this.overlay.create({
			kind: 'loading',
			element: el,
			cssClass: opts.cssClass,
			backdropDismiss: opts.backdropDismiss ?? false,
			showBackdrop: opts.showBackdrop,
			duration: opts.duration,
		});

		return Promise.resolve(handle);
	}

	dismiss(data?: any, role?: OverlayRole): Promise<boolean> {
		return this.overlay.dismissTop(data, role, 'loading');
	}

	getTop(): Promise<OverlayHandle | undefined> {
		return Promise.resolve(this.overlay.getTop('loading'));
	}
}
